<template>
  <div>
    <div
      v-show="isOpen"
      class="modal d-block"
      style="background:rgba(0,0,0,.55);z-index:10500;position:fixed;top:0;left:0;width:100%;height:100%"
      @click.self="store.close()"
    >
      <component v-if="store.component" :is="store.component" v-bind="store.props" @close="store.close()" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue";
import { useModalStore } from "@/stores/modal.store";

export default defineComponent({
  name: "MalawModalContainer",
  setup() {
    const store = useModalStore();
    onMounted(() => console.log('[MalawModalContainer] MONTÉ dans le DOM'));
    const isOpen = computed(() => {
      console.log('[MalawModalContainer] isOpen check:', store.isOpen);
      return store.isOpen;
    });
    return { store, isOpen };
  },
});
</script>
